/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetInventoryTransfersParams,
  InventoryTransfer,
  InventoryTransferAcceptInput,
  InventoryTransferCreateInput,
  InventoryTransferReportInput,
  InventoryTransfersList,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Inventory Transfers
 */
export const fleetInventoryTransfers = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryTransfersParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<InventoryTransfersList>(
      {url: `/fleets/${fleetSlug}/inventory-transfers`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetInventoryTransfersQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryTransfersParams>,) => {
    return [
    'fleets',fleetSlug,'inventory-transfers', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetInventoryTransfersQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventoryTransfers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryTransfersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryTransfers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryTransfersQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventoryTransfers>>> = ({ signal }) => fleetInventoryTransfers(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryTransfers>>, TError, TData>
}

export type FleetInventoryTransfersQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventoryTransfers>>>
export type FleetInventoryTransfersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventory Transfers
 */

export function useFleetInventoryTransfers<TData = Awaited<ReturnType<typeof fleetInventoryTransfers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetInventoryTransfersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryTransfers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryTransfersQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Fleet Inventory Transfer
 */
export const createFleetInventoryTransfer = (
    fleetSlug: MaybeRefOrGetter<string>,
    inventoryTransferCreateInput: MaybeRefOrGetter<InventoryTransferCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
inventoryTransferCreateInput = toValue(inventoryTransferCreateInput);

      return axiosClient<InventoryTransfer>(
      {url: `/fleets/${fleetSlug}/inventory-transfers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inventoryTransferCreateInput, signal
    },
      );
    }




export const getCreateFleetInventoryTransferMutationKey = () => ['createFleetInventoryTransfer'] as const;

export const getCreateFleetInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetInventoryTransfer>>, TError,CreateFleetInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetInventoryTransfer>>, TError,CreateFleetInventoryTransferMutationVariables, TContext> => {

const mutationKey = getCreateFleetInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetInventoryTransfer>>, CreateFleetInventoryTransferMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetInventoryTransfer(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetInventoryTransfer>>>
    export type CreateFleetInventoryTransferMutationBody = InventoryTransferCreateInput
    export type CreateFleetInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetInventoryTransferMutationVariables = {fleetSlug: string;data: InventoryTransferCreateInput}

    /**
 * @summary Create Fleet Inventory Transfer
 */
export const useCreateFleetInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetInventoryTransfer>>, TError,CreateFleetInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetInventoryTransfer>>,
        TError,
        CreateFleetInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetInventoryTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Inventory Transfer
 */
export const fleetInventoryTransfer = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);

      return axiosClient<InventoryTransfer>(
      {url: `/fleets/${fleetSlug}/inventory-transfers/${id}`, method: 'GET', signal
    },
      );
    }




export const getFleetInventoryTransferQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'inventory-transfers',id
    ] as const;
    }


export const getFleetInventoryTransferQueryOptions = <TData = Awaited<ReturnType<typeof fleetInventoryTransfer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryTransfer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetInventoryTransferQueryKey(fleetSlug,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetInventoryTransfer>>> = ({ signal }) => fleetInventoryTransfer(fleetSlug,id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryTransfer>>, TError, TData>
}

export type FleetInventoryTransferQueryResult = NonNullable<Awaited<ReturnType<typeof fleetInventoryTransfer>>>
export type FleetInventoryTransferQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Inventory Transfer
 */

export function useFleetInventoryTransfer<TData = Awaited<ReturnType<typeof fleetInventoryTransfer>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetInventoryTransfer>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetInventoryTransferQueryOptions(fleetSlug,id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Accept Fleet Inventory Transfer
 */
export const acceptFleetInventoryTransfer = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    inventoryTransferAcceptInput: MaybeRefOrGetter<InventoryTransferAcceptInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);
inventoryTransferAcceptInput = toValue(inventoryTransferAcceptInput);

      return axiosClient<InventoryTransfer>(
      {url: `/fleets/${fleetSlug}/inventory-transfers/${id}/accept`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: inventoryTransferAcceptInput, signal
    },
      );
    }




export const getAcceptFleetInventoryTransferMutationKey = () => ['acceptFleetInventoryTransfer'] as const;

export const getAcceptFleetInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetInventoryTransfer>>, TError,AcceptFleetInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptFleetInventoryTransfer>>, TError,AcceptFleetInventoryTransferMutationVariables, TContext> => {

const mutationKey = getAcceptFleetInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptFleetInventoryTransfer>>, AcceptFleetInventoryTransferMutationVariables> = (props) => {
          const {fleetSlug,id,data} = props ?? {};

          return  acceptFleetInventoryTransfer(fleetSlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptFleetInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof acceptFleetInventoryTransfer>>>
    export type AcceptFleetInventoryTransferMutationBody = InventoryTransferAcceptInput
    export type AcceptFleetInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type AcceptFleetInventoryTransferMutationVariables = {fleetSlug: string;id: string;data: InventoryTransferAcceptInput}

    /**
 * @summary Accept Fleet Inventory Transfer
 */
export const useAcceptFleetInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetInventoryTransfer>>, TError,AcceptFleetInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptFleetInventoryTransfer>>,
        TError,
        AcceptFleetInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptFleetInventoryTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel Fleet Inventory Transfer
 */
export const cancelFleetInventoryTransfer = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);

      return axiosClient<InventoryTransfer>(
      {url: `/fleets/${fleetSlug}/inventory-transfers/${id}/cancel`, method: 'PUT', signal
    },
      );
    }




export const getCancelFleetInventoryTransferMutationKey = () => ['cancelFleetInventoryTransfer'] as const;

export const getCancelFleetInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetInventoryTransfer>>, TError,CancelFleetInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelFleetInventoryTransfer>>, TError,CancelFleetInventoryTransferMutationVariables, TContext> => {

const mutationKey = getCancelFleetInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelFleetInventoryTransfer>>, CancelFleetInventoryTransferMutationVariables> = (props) => {
          const {fleetSlug,id} = props ?? {};

          return  cancelFleetInventoryTransfer(fleetSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelFleetInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof cancelFleetInventoryTransfer>>>

    export type CancelFleetInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type CancelFleetInventoryTransferMutationVariables = {fleetSlug: string;id: string}

    /**
 * @summary Cancel Fleet Inventory Transfer
 */
export const useCancelFleetInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetInventoryTransfer>>, TError,CancelFleetInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelFleetInventoryTransfer>>,
        TError,
        CancelFleetInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getCancelFleetInventoryTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Decline Fleet Inventory Transfer
 */
export const declineFleetInventoryTransfer = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);

      return axiosClient<InventoryTransfer>(
      {url: `/fleets/${fleetSlug}/inventory-transfers/${id}/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineFleetInventoryTransferMutationKey = () => ['declineFleetInventoryTransfer'] as const;

export const getDeclineFleetInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetInventoryTransfer>>, TError,DeclineFleetInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineFleetInventoryTransfer>>, TError,DeclineFleetInventoryTransferMutationVariables, TContext> => {

const mutationKey = getDeclineFleetInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineFleetInventoryTransfer>>, DeclineFleetInventoryTransferMutationVariables> = (props) => {
          const {fleetSlug,id} = props ?? {};

          return  declineFleetInventoryTransfer(fleetSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineFleetInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof declineFleetInventoryTransfer>>>

    export type DeclineFleetInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type DeclineFleetInventoryTransferMutationVariables = {fleetSlug: string;id: string}

    /**
 * @summary Decline Fleet Inventory Transfer
 */
export const useDeclineFleetInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetInventoryTransfer>>, TError,DeclineFleetInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineFleetInventoryTransfer>>,
        TError,
        DeclineFleetInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineFleetInventoryTransferMutationOptions(options), queryClient);
    }
    /**
 * @summary Report Fleet Inventory Transfer
 */
export const reportFleetInventoryTransfer = (
    fleetSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    inventoryTransferReportInput: MaybeRefOrGetter<InventoryTransferReportInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
id = toValue(id);
inventoryTransferReportInput = toValue(inventoryTransferReportInput);

      return axiosClient<InventoryTransfer>(
      {url: `/fleets/${fleetSlug}/inventory-transfers/${id}/report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inventoryTransferReportInput, signal
    },
      );
    }




export const getReportFleetInventoryTransferMutationKey = () => ['reportFleetInventoryTransfer'] as const;

export const getReportFleetInventoryTransferMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportFleetInventoryTransfer>>, TError,ReportFleetInventoryTransferMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reportFleetInventoryTransfer>>, TError,ReportFleetInventoryTransferMutationVariables, TContext> => {

const mutationKey = getReportFleetInventoryTransferMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportFleetInventoryTransfer>>, ReportFleetInventoryTransferMutationVariables> = (props) => {
          const {fleetSlug,id,data} = props ?? {};

          return  reportFleetInventoryTransfer(fleetSlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportFleetInventoryTransferMutationResult = NonNullable<Awaited<ReturnType<typeof reportFleetInventoryTransfer>>>
    export type ReportFleetInventoryTransferMutationBody = InventoryTransferReportInput
    export type ReportFleetInventoryTransferMutationError = ErrorType<ValidationError | StandardError>
    export type ReportFleetInventoryTransferMutationVariables = {fleetSlug: string;id: string;data: InventoryTransferReportInput}

    /**
 * @summary Report Fleet Inventory Transfer
 */
export const useReportFleetInventoryTransfer = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportFleetInventoryTransfer>>, TError,ReportFleetInventoryTransferMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof reportFleetInventoryTransfer>>,
        TError,
        ReportFleetInventoryTransferMutationVariables,
        TContext
      > => {
      return useMutation(getReportFleetInventoryTransferMutationOptions(options), queryClient);
    }
